<template>
    <div>
      <Transfer_goods_add/>
    </div>
  </template>
  
  <script>
  import Transfer_goods_add from "@/components/adminArin/pos_system/warehouse/warehouse_all/Transfer_goods_add";
  export default {
    name: "Transfergoodsadd",
    components: {
      Transfer_goods_add
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  